import jssKeyframes from 'jss-keyframes';

const keyframes: (...args: any[]) => any = jssKeyframes;

export default keyframes;
